import { FC, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { PopularRequest } from 'modules/marketing-pages/service';
import RequestDetailsTable from '@z-components/molecules/RequestDetailsTable';

import ProCard from 'modules/marketing-pages/components/ListPros/ProCard';
import ReadMore from '@z-components/atoms/ReadMore';
import { logEvent } from 'utils/analytics';
import styles from './VerticalPopularRequestItem.module.scss';

interface Props {
  isReviewsQAEnabled: boolean;
  popularRequest: PopularRequest;
}

const RequestDetails: FC<Props> = ({
  popularRequest: {
    request: { fields, jobTypeId },
    sampleApplyInfo,
  },
  isReviewsQAEnabled,
}) => {
  const {
    i18n: { language },
    t,
  } = useTranslation('marketingPages');
  const requestFieldsWithValues = useMemo(
    () =>
      fields.filter(({ value }) => {
        if (typeof value === 'string' || Array.isArray(value)) {
          return value.length > 0;
        } else if (typeof value === 'object') {
          return Object.keys(value).length > 0;
        }
        return false;
      }),
    [fields]
  );
  const handleGoogleAnalytics = useCallback(
    (eventType: string) => {
      logEvent(`LandingPagePro:${jobTypeId}`, `${eventType}`);
    },
    [jobTypeId]
  );

  const { proProfile } = sampleApplyInfo;

  return (
    <div className={styles.container}>
      <ReadMore language={language as 'en' | 'ja'}>
        <RequestDetailsTable
          caption={t('requestDetails.requestDetailsTableCaption')}
          language={language as 'en' | 'ja'}
          requestFields={requestFieldsWithValues}
        />
      </ReadMore>
      <div className={styles['pro-card-container']}>
        <ProCard
          onGoogleAnalytics={handleGoogleAnalytics}
          pro={proProfile}
          jobTypeId={jobTypeId}
          applyMessage={sampleApplyInfo.coverLetter}
          isReviewsQAEnabled={isReviewsQAEnabled}
        />
      </div>
    </div>
  );
};

export default RequestDetails;
